<template>
  <section class="contact-section">
    <div class="container">
      <div class="grid is-12">
        <div class="buttons">
          <a
            class="button button-primary button-primary--gray home-module-button"
            href="/contact-us"
            target=""
          >
            <div class="text">
              <h2>Contact us</h2>
              <p>
                Contact our Customer Concierge team for all your insurance needs
              </p>
            </div>
            <div class="icon">
              <vue-fontawesome icon="far fa-envelope" />
            </div>
          </a>
          <a
            class="button button-primary button-primary--gray home-module-button"
            href="/faq"
            target=""
          >
            <div class="text">
              <h2>FAQ</h2>
              <p>Find responses to the most common questions</p>
            </div>
            <div class="icon">
              <vue-fontawesome icon="far fa-list" />
            </div>
          </a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ContactUs'
};
</script>

<style lang="scss" scoped>
section.contact-section {
  background-color: $footer-background-color;
  margin: 0 auto;

  div.container {
    padding: $--pcom-spacing-large 0 $--pcom-spacing-x-large;
  }
}

div.box {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 320px;
  max-width: 2560px;
}

div.buttons {
  display: flex;
  justify-content: center;
  flex-direction: row;
  @media (max-width: 999px) {
    flex-direction: column;
  }

  a.button {
    @media (max-width: 999px) {
      margin: 0.5rem auto;
    }
    display: flex;
    flex-direction: row;
    position: relative;
    align-items: center;
    text-decoration: none;
    min-height: 74px;
    margin: 0 0.5rem;
    padding: 16px 0 16px 8px;
    box-sizing: border-box;
    border-radius: 8px;
    width: 55vw;
    min-width: 265px;
    max-width: 555px;

    div.text {
      min-width: 64px;
      padding: 0 8px;
      flex: 1 1 auto;
      overflow: hidden;

      h2 {
        font: 600 1rem / calc(6px + 2.125ex) Porsche Next, Arial Narrow, Arial,
          Heiti SC, SimHei, sans-serif;
      }
      p {
        margin: 0;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    div.icon {
      flex: 0 0 auto;
      padding: 0 16px;
    }
  }
}
</style>
